module.exports = __webpack_public_path__ + "media/images/icons8-personal-trainer-1525b097a1b66f8190c09954a87d00e8.svg";